import React from "react";
import property from "../property.json";

import { BsEnvelope, BsTelephone } from "react-icons/bs";
import { AiOutlineLinkedin } from "react-icons/ai";
import { HiOutlineHome } from "react-icons/hi";
const iconStyles = { color: "#03a9f4", fontSize: "1em" };
function Left() {
  return (
    <div className="left-side">
      <div className="name">
        <h2>THASNEM BANU ABDUL LATHEEF</h2>
        <br />
        <h3>Full-Stack Developer</h3>
      </div>
      <div className="contact-info">
        <h3 style={{paddingLeft: '10px'}}>CONTACT ME</h3>
        <div className="contact-info-flex">
          <span className="icon" style={{ top: "63px" }}>
            <BsTelephone style={iconStyles} />
          </span>
          <span className="contact-text">+46 76 433 46 11</span>

        </div>
        <div className="contact-info-flex">
          <span className="icon" style={{ top: "87px" }}>
            <BsEnvelope style={iconStyles} />
          </span>
          <span className="contact-text">thasnem.latheef.dev@gmail.com</span>

        </div>
        <div className="contact-info-flex">
          <span className="icon" style={{ top: "109px" }}>
            <AiOutlineLinkedin style={iconStyles} />
          </span>
          <span className="contact-text">
            <a href="https://www.linkedin.com/in/thasnem-latheef-dev/" style={{ color: "white", textDecoration: "none" }}>linkedin.com/thasnem-latheef-dev</a>
          </span>

        </div>
        <div className="contact-info-flex">
          <span className="icon" style={{ top: "131px" }}>
            <HiOutlineHome style={iconStyles} />
          </span>
          <span style={{ paddingTop: "4px" }}>Sodertalje, Stockholm, Sweden</span>

        </div>
      </div>
      <div className="skillsClass">
        <h3>SKILLS</h3>
        <ul>
          {property.skills.map((skill) => {
            return (
              <li>

                {skill.name}

              </li>
            );
          })}
        </ul>
      </div>
      <div className="education">
        <h3>EDUCATION</h3>
        <ul>
          <li>
            <h4 className="education-timeline">2014 - 2018</h4>
            <h4>BACHELORS IN ELECTRONICS & COMMUNICATION ENGINEERING</h4>
            <h4>Madras Institute Of Technology, Chennai, India</h4>
            <h5>First class with Distinction - 8.59 CGPA</h5>
          </li>
          {/* <li>
            <h4 className="education-timeline">2012 - 2014</h4>
            <h4>HIGHER SECONDARY SCHOOLING</h4>
            <h5>Percentage - 97.9%</h5>
          </li>
          <li>
            <h4 className="education-timeline">2012</h4>
            <h4>SECONDARY SCHOOLING</h4>
            <h5>Percentage - 98.4%</h5>
          </li> */}
        </ul>
      </div>
      <div className="achievements">
        <h3>ACHIEVEMENTS & CERTIFICATIONS</h3>
        <ul>
          <li>Java from Udemy.</li>
          <li>ReactJS certification – TCS Internal</li>
          <li>Process – Agile way of working – TCS Internal</li>
          <li>
            Received “Certificate of Excellence” from Client for work done
            during respective quarter in 2020 and 2022
          </li>
          <li>
            Won “Applause award” for quick learning of technology needed for the
            project.
          </li>
          <li>
            Awarded with “T-factor champ” and “Learning Achievement award” for
            continuous learning & clearing milestone challenges.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Left;
